import RequestHandler from "./RequestHandler";

function ProductsAPI() {
    const baseProductsAPI = "products";

    async function getProductsList(
        itemsPerPage,
        filters,
        offset = 0,
        defaultSortBy = null,
        defaultSortDirection = null
    ) {
        try {
            const skip = offset * itemsPerPage;
            const sortBy = defaultSortBy || "createdAt";
            const sortDirection = defaultSortDirection || "DESC";
            const URL = `${baseProductsAPI}/list?skip=${skip}&take=${itemsPerPage}&sortBy=${sortBy}&sortDirection=${sortDirection}`;
            const result = await RequestHandler.post(URL, filters);
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getProductsPartner(
        organizationId,
        itemsPerPage,
        offset = 0
    ) {
        try {
            const skip = offset * itemsPerPage;
            const result = await RequestHandler.post(
                `${baseProductsAPI}/partner/${organizationId}?skip=${skip}&take=${itemsPerPage}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function getProductDetails(productId) {
        try {
            const result = await RequestHandler.get(
                `${baseProductsAPI}/details/${productId}`
            );
            return result;
        } catch (error) {
            console.log(error);
        }
    }

    async function getProductsInfo(productId) {
        try {
            const result = await RequestHandler.get(
                `${baseProductsAPI}/info/${productId}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    return {
        getProductsList,
        getProductsPartner,
        getProductDetails,
        getProductsInfo,
    };
}

export default ProductsAPI();
